const getters = {
  sidebar: state => state.app.sidebar,
  permission_routers: state => state.permission.menu,
  visitedViews: state => state.app.visitedViews,
  // userId: state => state.user.userId,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  language: state => state.app.language,
  companies: state => state.user.companies,
  permissions: state => state.user.permissions,
  completeNumber (state) {
    return state.singleAnswers.filter(item => item).length +
      state.multipleAnswers.filter(item => JSON.stringify(item) !== '[]' && JSON.stringify(item) !== undefined && JSON.stringify(item) !== 'null').length +
      state.judgeAnswers.filter(item => item).length +
      state.fillAnswers.filter(item => item).length
  },
  unreadMsgCount: state => state.unreadMsgCount
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js